import VTextField from './VTextField'

/* istanbul ignore next */
VTextField.install = function install (Vue) {
  Vue.component(VTextField.name, VTextField)
}

export default VTextField



// WEBPACK FOOTER //
// ./src/components/VTextField/index.js